<template>

        <v-input
            hide-details
            id="head-biker-search"
            role="button"
            aria-label="Search"
            class="c-search-bikes flex-grow-0"
            :class="{overlayed: modelSearchStore.modelSearchOpen, 'has-model': !!model}"
        >
            <div class="v-field v-field--variant-outlined cursor-pointer" :class="{'bg-orange-lighten-5': $vuetify.display.smAndDown && model && modelSearchStore.modelSearchOpen, 'rounded-0': $vuetify.display.smAndDown}">
                <div class="v-field__prepend-inner ml-4">
                    <v-icon :icon="mdiAtv" size="28"/>
                </div>
                <div class="v-field__field">
                    <div class="v-field__input" :class="{'pt-1': $vuetify.display.smAndDown}">
                        <div id="c-search-bikes__header-wrap" class="d-flex align-center justify-space-between flex-grow-1">
                            <client-only>
                                <span id="c-search-bikes__header" class="overflow-hidden">{{ header }}</span>
                            </client-only>
                            <v-icon class="ml-0 ml-sm-4 c-menu-icon" :class="{rotate: modelSearchStore.modelSearchOpen}" size="small" :icon="mdiChevronDown"/>
                        </div>
                        <div v-if="model" class="text-black text-tiny flex-1-1-100">
                            <v-btn
                                :prepend-icon="mdiClose"
                                class="text-black text-tiny h-auto px-0 opacity-100"
                                @click.stop="router.get(route('eshop.forgetModelSearch'), {}, {onSuccess: () => {store.resetSelected(); modelSearchStore.modelSearchOpen = false}});"
                                elevation="0"
                                variant="plain"
                            >
                                <span class="text-decoration-underline">{{$t('model-search.filter_storno')}}</span>
                            </v-btn>
                        </div>
                        <client-only v-else>
                            <div class="text-black text-tiny flex-1-1-100 overflow-hidden text-no-wrap" style="text-overflow: ellipsis">{{ caption }}</div>
                        </client-only>
                    </div>
                </div>
                <div class="v-field__outline">
                    <div class="v-field__outline__start"></div>
                    <div class="v-field__outline__end"></div>
                </div>
            </div>
            <v-menu
                activator="parent"
                :model-value="modelSearchStore.modelSearchOpen"
                location="bottom center"
                :offset="$vuetify.display.lgAndUp ? '-18px' : ($vuetify.display.smAndDown ? '-4px' : undefined)"
                :close-on-content-click="false"
                :target="$vuetify.display.lgAndUp ? '#app-bar-title' : 'parent'"
                class="full-overlay"
                :transition="!!modelSearch?.selects ? 'dialog-transition' : false"
                @update:model-value="modelSearchStore.modelSearchOpen = $event"
            >
                <div>
                    <v-dialog-transition>
                        <div v-show="!!modelSearch?.selects && modelSearchStore.modelSearchOpen" class="model-search-menu">
                            <model-search
                                :model-search="modelSearch.selects"
                                :model="modelSearch.model"
                                prevent-click
                                on-year-search
                                :bottom-not-rounded="!!Object.values($page.props.searchedBikes)?.length"
                                :handle-overlay="!Object.values($page.props.searchedBikes)?.length"
                                class="pt-0"
                                :on-search-visit="!$page.props.product && !$page.props.group && !$page.props.searchedQuery"
                                style="margin-bottom: -1px"
                                :class="Object.values($page.props.searchedBikes)?.length ? 'border-b':''"
                                @close-overlay="modelSearchStore.modelSearchOpen = false"
                            ></model-search>
                            <last-search-garage v-if="Object.values($page.props.searchedBikes)?.length"
                                                @close-overlay="modelSearchStore.modelSearchOpen = false"></last-search-garage>
                        </div>
                    </v-dialog-transition>
                </div>
            </v-menu>
            <v-overlay
                :model-value="modelSearchStore.modelSearchOpen"
                persistent
                scrim="#000"
                :attach="true"
                @click:outside="(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    modelSearchStore.modelSearchOpen = false;
                }"
                @click.stop.prevent
            >
            </v-overlay>
        </v-input>
</template>

<script setup>
import {mdiChevronDown, mdiClose, mdiAtv} from "@mdi/js";
import {computed, defineAsyncComponent, inject, onMounted, watch} from "vue";
import {useDisplay} from "vuetify";
import ClientOnly from "../../components/ClientOnly.vue";
import {useOverlayStore} from "./store/overlay";
import pinia from "../../../plugins/pinia";
import {router} from "@inertiajs/vue3";
import {useSearchStore} from "./store/search";
import {useOverlayModalsStore} from "./store/overlayModals.js";
import {trans} from "laravel-vue-i18n";
import LastSearchGarage from "./LastSearchGarage.vue";

const props = defineProps({
    modelSearch: Object,
    heightInfoBar: Number,
    searchedBikes: [Array, Object],
})
const store = useSearchStore(pinia);
const route = inject('route');
const model = computed(() => props.modelSearch?.model?.full_name
)
const overlayStore = useOverlayStore(pinia);
const modelSearchStore = useOverlayModalsStore(pinia);
const ModelSearch = defineAsyncComponent(() => import('../../../motonet/modules/eshop/frontend/ModelSearch.vue'));

watch(() => modelSearchStore.modelSearchOpen, (now) => {
    overlayStore.overlayMenu = now
    const container = document.getElementsByClassName('v-overlay-container');
    if(container.length && now){
        container[0].classList.add('has-login-overlay')
    }
    if (!now) {
        if(container.length){
            container[0].classList.remove('has-login-overlay')
        }
    }
});
const {lgAndUp} = useDisplay();
const header = computed(() => {
    if(model.value){
        return model.value;
    }
    if (lgAndUp.value) {
        return trans('model-search.motorbike_search');
    }
    return trans('model-search.search_motorbike');
})
const caption = computed(() => {
    if (lgAndUp.value) {
        return trans('model-search.not_active');
    }
    return trans('model-search.showing_all');
})
const hasSearchedBikes = computed(() => {
    return Object.values(props.searchedBikes).length
})

const include = () => {
    if(typeof document === "undefined") return [];
    return [document.querySelector('.search-included, .search-included *')]
};
onMounted(()=> {
    document.querySelector('.c-overlay')?.addEventListener('click', () => {
        modelSearchStore.modelSearchOpen = false;
    })
})
</script>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.v-icon.c-menu-icon {
    transition: transform .3s $standard-easing;

    &.rotate {
        transform: rotate3d(0, 0, 1, 180deg);
    }
}
.c-search-bikes {
    color: map.get($blue, base);

    .v-field__outline {
        border-radius: var(--motonet-border-radius);
    }

    .v-field__prepend-inner {
        padding: 0;
        display: flex;
        align-items: center;
        @media screen and (max-width: 400px) {
            display: none;
        }
    }

    .v-field__input {
        row-gap: 0;
        padding-block: 8px;
    }

    &.overlayed{
        .v-field{
            z-index: 3000;
            background-color: white;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
        .v-field__outline *{
            border: none;
        }
    }
    &.has-model{
        color: map.get($orange, base);
    }
}
#c-search-bikes__header-wrap{
    max-width: 100%;
}
#c-search-bikes__header{
    text-overflow: ellipsis;
}

.model-search-menu {
    scrollbar-width: none;
    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        height: calc(100dvh - 109px);
        overflow: scroll;
    }
    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
